/**
 * Constantes de monetización de la plataforma.
 * Preparado para futura integración con pasarela de pago (ej. Mercado Pago)
 * y comisión sobre órdenes de servicios.
 */

/** Comisión de la plataforma sobre el monto de la orden (0 = sin comisión, 0.10 = 10%) */
export const PLATFORM_COMMISSION_RATE = 0;

/**
 * Calcula el monto que retiene la plataforma por comisión.
 * @param {number} orderAmount - Monto total de la orden
 * @returns {number} Comisión en la misma unidad que orderAmount
 */
export function getPlatformFee(orderAmount) {
  if (typeof orderAmount !== 'number' || orderAmount <= 0) return 0;
  return Math.round(orderAmount * PLATFORM_COMMISSION_RATE * 100) / 100;
}

/**
 * Calcula el monto que recibe el vendedor tras descontar la comisión.
 * @param {number} orderAmount - Monto total de la orden
 * @returns {number} Monto neto para el vendedor
 */
export function getSellerAmount(orderAmount) {
  if (typeof orderAmount !== 'number' || orderAmount <= 0) return 0;
  const fee = getPlatformFee(orderAmount);
  return Math.round((orderAmount - fee) * 100) / 100;
}
